import { saveAs } from "file-saver";
import { Lead, formatLeadDateTime } from "./constants";

const escapeCsvCell = (value: any) => {
  const stringValue = String(value ?? "");
  if (/[",\n\r]/.test(stringValue)) {
    return `"${stringValue.replace(/"/g, '""')}"`;
  }
  return stringValue;
};

function buildCsv(columns: string[], rows: Array<Record<string, any>>): Blob {
  const csvRows = [
    columns.map(escapeCsvCell).join(","),
    ...rows.map((row) => columns.map((column) => escapeCsvCell(row[column])).join(",")),
  ];
  return new Blob([csvRows.join("\n")], { type: "text/csv;charset=utf-8;" });
}

interface ExportLeadsOptions {
  leads: Lead[];
  filename?: string;
}

export function exportLeadsToCSV({ leads, filename = "LeadsManagement" }: ExportLeadsOptions) {
  const columns = [
    "ID", "Full Name", "Email", "Phone", "Brand Name", "Status",
    "Business Industry", "Loan Purpose", "Borrow Amount", "Monthly Revenue",
    "Credit Rating", "Time In Business", "Zip Code", "Business Name",
    "User Unique ID", "Traffic Source", "Ad ID",
    "Ad Platform Click ID", "Date Of Acquisition", "Reported At",
  ];
  const rows = leads.map((lead) => ({
    "ID": lead.id,
    "Full Name": lead.name,
    "Email": lead.email,
    "Phone": lead.phone,
    "Brand Name": lead.brand,
    "Status": lead.status,
    "Business Industry": lead.industry,
    "Loan Purpose": lead.loanPurpose,
    "Borrow Amount": lead.amount,
    "Monthly Revenue": lead.revenue,
    "Credit Rating": lead.credit,
    "Time In Business": lead.timeInBusiness,
    "Zip Code": lead.zip,
    "Business Name": lead.businessName,
    "User Unique ID": lead.userUniqueId,
    "Traffic Source": lead.trafficSource,
    "Ad ID": lead.adId,
    "Ad Platform Click ID": lead.adPlatformClickId,
    "Date Of Acquisition": formatLeadDateTime(lead.date),
    "Reported At": formatLeadDateTime(lead.reportedAt),
  }));
  saveAs(buildCsv(columns, rows), `${filename}.csv`);
}

interface ExportLeadsByDayOptions {
  rows: Array<{ label: string; count: number }>;
  filename?: string;
}

export function exportLeadsByDayToCSV({ rows, filename = "LeadsByDay" }: ExportLeadsByDayOptions) {
  const columns = ["Date", "Count"];
  const csvRows = rows.map((row) => ({ Date: row.label, Count: row.count }));
  saveAs(buildCsv(columns, csvRows), `${filename}.csv`);
}
